import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LPadrao from "@/layouts/LPadrao/LPadrao.vue"
  import { TProjetos } from "@/components/Projetos"

export default /*#__PURE__*/_defineComponent({
  __name: 'ListaDeProjetos',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LPadrao, { class: "Projetos" }, {
    default: _withCtx(() => [
      _createVNode(_unref(TProjetos))
    ]),
    _: 1
  }))
}
}

})